var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"culture-tags"},_vm._l((_vm.tags),function(tag){return _c('li',{key:tag},[_vm._v(_vm._s(_vm.label(tag)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }